// Koşan Düğme — Katalog 2024 verileri (frontend mock)
// image: ortalanmış ürün görseli, band: katalogdaki tüm ölçüleri gösteren şerit

const P = "/images/products";
const T = "/images/thumbs";

export const ASSETS = {
  logoFull: `${P}/logo_horizontal.png`,
  logoIcon: `${P}/logo_mark.png`,
  logoStacked: `${P}/logo_stacked.png`,
  heroDenim: `${P}/hero_denim.jpg`,
  heroLeather: `${P}/hero_leather.jpg`,
  certOekotex: `${P}/cert_oekotex.png`,
  certInditex: `${P}/cert_inditex.png`,
};

export const SOCIAL = {
  linkedin: "https://www.linkedin.com/company/82834284/",
  instagram: "https://www.instagram.com/kosan.dugme/",
};

export const CONTACT = {
  phone: "+90 212 479 15 47",
  phoneHref: "tel:+902124791547",
  whatsapp: "0541 513 11 74",
  whatsappHref: "https://wa.me/905415131174",
  whatsapp2: "0541 513 11 71",
  whatsappHref2: "https://wa.me/905415131171",
  emails: ["kosan@kosandugme.com", "merter@kosandugme.com"],
  address: "Sanayi Mah. Gürbüz Sok. No: 44 Güngören / İstanbul – Türkiye",
  branch: "Merter Şubesi — Karakullukçu İş Hanı, Güngören / İstanbul",
  mapsEmbed:
    "https://maps.google.com/maps?q=Sanayi%20Mahallesi%20G%C3%BCrb%C3%BCz%20Sokak%20No%3A44%20G%C3%BCng%C3%B6ren%20%C4%B0stanbul&t=&z=15&ie=UTF8&iwloc=&output=embed",
  rating: "4.8",
  reviews: "59",
};

export const LEGAL = {
  company: "Koşan Düğme İmalat Sanayi ve Ticaret Ltd. Şti.",
  address: "Sanayi Mah. Gürbüz Sok. No: 44 Güngören / İstanbul – Türkiye",
  email: "kosan@kosandugme.com",
  phone: "+90 212 479 15 47",
  mersis: "0580003524800016",
  ticaretSicil: "312351",
  kep: "kosandugme@hs01.kep.tr",
  updated: "Haziran 2026",
};

export const BRANCHES = [
  {
    id: "fabrika",
    name: "Fabrika (Merkez)",
    address: "Sanayi Mah. Gürbüz Sok. No: 44, Güngören / İstanbul – Türkiye",
    phone: "+90 212 479 15 47",
    phoneHref: "tel:+902124791547",
    mapsEmbed:
      "https://maps.google.com/maps?q=Sanayi%20Mahallesi%20G%C3%BCrb%C3%BCz%20Sokak%20No%3A44%20G%C3%BCng%C3%B6ren%20%C4%B0stanbul&t=&z=16&ie=UTF8&iwloc=&output=embed",
    mapsLink: "https://maps.google.com/?q=Koşan+Düğme+Sanayi+Mahallesi+Gürbüz+Sokak+44+Güngören",
  },
  {
    id: "merter",
    name: "Merter Şubesi",
    address:
      "Mehmet Nesih Özmen Mah. Savaş Cd. No: 4 (Karakullukçu İş Hanı), 34173 Güngören / İstanbul",
    phone: "+90 505 788 03 29",
    phoneHref: "tel:+905057880329",
    mapsEmbed:
      "https://maps.google.com/maps?q=Ko%C5%9Fan%20D%C3%BC%C4%9Fme%20Savas%20Cd%20No%3A4%20Mehmet%20Nesih%20%C3%96zmen%20G%C3%BCng%C3%B6ren&t=&z=17&ie=UTF8&iwloc=&output=embed",
    mapsLink: "https://maps.app.goo.gl/gSkUJJPz3qnuaF4TA",
    media: {
      video: "/videos/merter.mp4",
      poster: "/images/branches/merter-poster.jpg",
      photos: [
        { image: "/images/branches/merter-1.jpg", label: "Merter şube — dış cephe" },
        { image: "/images/branches/merter-2.jpg", label: "Merter şube — mağaza içi" },
      ],
    },
  },
];

// Güngören fabrika ve satış mağazası kareleri
export const FACTORY_PHOTOS = [
  { image: "/images/branches/fabrika-1.jpg", label: "Fabrika satış mağazamız — Güngören" },
  { image: "/images/branches/fabrika-2.jpg", label: "Showroom ve numune alanı" },
  { image: "/images/branches/fabrika-3.jpg", label: "Enjeksiyon ve pres hattı" },
  { image: "/images/branches/fabrika-4.jpg", label: "Otomatik pres üretim hattı" },
  { image: "/images/branches/fabrika-5.jpg", label: "Üretim ve montaj bölümü" },
];

// Google Maps üzerindeki müşteri değerlendirmeleri (4.8 / 5 · 59 yorum)
export const REVIEWS = [
  { author: "Murat Yılmaz", initial: "M", stars: 5, date: "3 ay önce", text: "Kalitesi ve servis hızı gerçekten çok iyi. Çıtçıt ve kot düğmelerinde uzun süredir çalışıyoruz, hiçbir sorun yaşamadık. Tavsiye ederim." },
  { author: "Elif Kaya", initial: "E", stars: 5, date: "5 ay önce", text: "Numune taleplerimize aynı gün dönüş yaptılar. Renk seçenekleri çok geniş, aradığımız tonu birebir tutturdular. Teşekkürler Koşan." },
  { author: "Ahmet Demir", initial: "A", stars: 5, date: "6 ay önce", text: "Perçin ve kuşgözü siparişlerimiz zamanında elimize ulaştı. Fiyat/performans açısından sektörde çok başarılılar." },
  { author: "Selin Öztürk", initial: "S", stars: 4, date: "8 ay önce", text: "Ürün kalitesi çok iyi, ilgili bir ekip. Yoğun dönemde teslimat biraz uzadı ama sonuçtan memnun kaldık." },
  { author: "Hakan Şahin", initial: "H", stars: 5, date: "9 ay önce", text: "Özel logo baskılı kot düğmesi yaptırdık, sonuç harika oldu. İşçilik ve kaplama kalitesi üst düzey." },
  { author: "Zeynep Arslan", initial: "Z", stars: 5, date: "1 yıl önce", text: "Toka ve stoper çeşitliliği çok geniş. Merter şubesinden alışveriş yapmak çok pratik. Kesinlikle tavsiye ederim." },
];

export const ABOUT_TEXT = {
  title: "HAKKIMIZDA",
  paragraphs: [
    "Koşan Düğme İmalat San. ve Tic. Ltd. Şti. olarak sektöre sunduğumuz geniş ürün yelpazesi ve kaliteli hizmet anlayışımızla, modanın ve işlevselliğin buluştuğu noktada yer alıyoruz.",
    "Üretimin her aşamasında yenilikçi yaklaşımlar benimseyerek müşteri ihtiyaçlarını göz önünde bulunduruyor, sürdürdüğümüz çalışmalarla sektörde konumumuzu güçlendirmeye devam ediyoruz.",
    "Fabrikamızın verimli ve modern yapısını Merter şubemiz ile güçlendirerek, müşteri odaklı servis anlayışımızla başarılı bir süreç yönetimi gerçekleştiriyoruz.",
    "1993 yılından bu yana sunduğumuz çözümlerle müşteri memnuniyetini ve ürünlerimizdeki kaliteyi her daim önceliğimiz haline getiriyoruz.",
  ],
};

export const STATS = [
  { value: 32, suffix: "+", label: "Yıllık Deneyim" },
  { value: 1000, suffix: "+", label: "Ürün Çeşidi" },
  { value: 48, suffix: "", label: "Renk & Kaplama Seçeneği" },
  { value: 12, suffix: "", label: "Ürün Kategorisi" },
];

export const WHY_US = [
  { icon: "PenTool", title: "Modern Tasarımlar", text: "Modayı ve piyasanın taleplerini iyi analiz ederek modern tasarımlar üretiriz." },
  { icon: "Timer", title: "Hızlı & Zamanında", text: "Siparişleriniz zamanında teslim edilerek işinizin aksaklığa uğramamasını sağlarız." },
  { icon: "MousePointerClick", title: "Online Sistem", text: "Sitemiz üzerinden ürünlerimizi inceleyebilir, talep ve siparişlerinizi kolayca iletebilirsiniz." },
  { icon: "Award", title: "Yüksek Kalite", text: "Yüksek kalitede hammaddeler ile kaliteli ürünler üretiriz." },
  { icon: "Globe2", title: "Global Odaklı", text: "Müşteri taleplerine ve piyasanın ihtiyaçlarına göre ithalat ve ihracat yaparız." },
  { icon: "Puzzle", title: "Talebe Çözüm", text: "Talep ettiğiniz özel ürünler için gereken çalışmaları yaparak, size özel çözümü sunarız." },
];

export const CATEGORIES = [
  {
    id: "kafa",
    name: "KAFA",
    desc: "Çıtçıt ve perçin sistemleri için paslanmaz, pirinç, zamak ve plastik kafa modelleri.",
    image: `${T}/kafa_paslanmaz_klasik.jpg`,
    items: [
      { name: "Paslanmaz Klasik Kafa", image: `${T}/kafa_paslanmaz_klasik.jpg`, band: `${P}/kafa_paslanmaz_klasik.jpg`, sizes: ["10 mm", "12,5 mm", "15 mm", "17 mm", "20 mm", "25 mm", "30 mm"] },
      { name: "Paslanmaz Para Model Kafa", image: `${T}/kafa_paslanmaz_para.jpg`, band: `${P}/kafa_paslanmaz_para.jpg`, sizes: ["12,5 mm", "15 mm", "17 mm", "20 mm", "30 mm"] },
      { name: "Pirinç Kafa", image: `${T}/kafa_princ.jpg`, band: `${P}/kafa_princ.jpg`, sizes: ["9,5 mm", "12,5 mm", "15 mm", "17 mm", "21 mm"] },
      { name: "Zamak Kafa Modelleri", image: `${T}/kafa_zamak.jpg`, band: `${P}/kafa_zamak.jpg`, sizes: ["9,5 mm", "12,5 mm", "15 mm", "17 mm", "20 mm", "21 mm", "25 mm", "30 mm"] },
      { name: "Plastik Kafa Modelleri", image: `${T}/kafa_plastik.jpg`, band: `${P}/kafa_plastik.jpg`, sizes: ["9,5 mm", "12,5 mm", "15 mm", "17 mm"] },
    ],
  },
  {
    id: "alt-parca",
    name: "ALT PARÇA",
    desc: "54, 61, VT2, Alfa ve klasik sistem paslanmaz & pirinç çıtçıt alt parçaları.",
    image: `${T}/altp_501klasik.jpg`,
    items: [
      { name: "54 – 3 Parça Paslanmaz Düz Alt", image: `${T}/altp_54duz.jpg`, band: `${P}/altp_54duz.jpg`, sizes: ["15 mm"] },
      { name: "54 – 3 Parça Paslanmaz Yıldız Alt", image: `${T}/altp_54yildiz.jpg`, band: `${P}/altp_54yildiz.jpg`, sizes: ["15 mm"] },
      { name: "54 – 3 Parça Pirinç Alt", image: `${T}/altp_54princ.jpg`, band: `${P}/altp_54princ.jpg`, sizes: ["15 mm"] },
      { name: "VT2 – 4 Parça Paslanmaz Alt", image: `${T}/altp_vt2.jpg`, band: `${P}/altp_vt2.jpg`, sizes: ["12,5 mm"] },
      { name: "Alfa – 4 Parça Paslanmaz Alt", image: `${T}/altp_alfa.jpg`, band: `${P}/altp_alfa.jpg`, sizes: ["12,5 mm", "15 mm", "17 mm", "20 mm"] },
      { name: "61 Sistem – 4 Parça Paslanmaz Alt", image: `${T}/altp_61.jpg`, band: `${P}/altp_61.jpg`, sizes: ["12,5 mm", "15 mm", "17 mm"] },
      { name: "Mini 61 Sistem – 4 Parça Paslanmaz Alt", image: `${T}/altp_mini61.jpg`, band: `${P}/altp_mini61.jpg`, sizes: ["10 mm"] },
      { name: "501 Klasik – 4 Parça Paslanmaz Alt", image: `${T}/altp_501klasik.jpg`, band: `${P}/altp_501klasik.jpg`, sizes: ["12,5 mm"] },
      { name: "503 Klasik – 4 Parça Paslanmaz Alt", image: `${T}/altp_503klasik.jpg`, band: `${P}/altp_503klasik.jpg`, sizes: ["15 mm"] },
      { name: "884 – 4 Parça Paslanmaz Alt", image: `${T}/altp_884.jpg`, band: `${P}/altp_884.jpg`, sizes: ["17 mm", "20 mm"] },
      { name: "501 Alm. Çivili – 4 Parça Paslanmaz Alt", image: `${T}/altp_501alm.jpg`, band: `${P}/altp_501alm.jpg`, sizes: ["12,5 mm"] },
      { name: "503 Alm. Çivili – 4 Parça Paslanmaz Alt", image: `${T}/altp_503alm.jpg`, band: `${P}/altp_503alm.jpg`, sizes: ["15 mm"] },
      { name: "713 – 4 Parça Paslanmaz Alt", image: `${T}/altp_713.jpg`, band: `${P}/altp_713.jpg`, sizes: ["9,5 mm"] },
      { name: "852 – 4 Parça Paslanmaz Alt", image: `${T}/altp_852.jpg`, band: `${P}/altp_852.jpg`, sizes: ["21 mm"] },
    ],
  },
  {
    id: "klikit",
    name: "KLIKIT",
    desc: "Gömlek ve bebek grubu için pratik çıtçıt (klikit) sistemleri.",
    image: `${T}/klikit_105.jpg`,
    items: [
      { name: "9,5 mm Klikit", image: `${T}/klikit_95.jpg`, band: `${P}/klikit_95.jpg`, sizes: ["9,5 mm"] },
      { name: "10,5 mm Klikit", image: `${T}/klikit_105.jpg`, band: `${P}/klikit_105.jpg`, sizes: ["10,5 mm"] },
    ],
  },
  {
    id: "kusgozu",
    name: "KUŞGÖZÜ",
    desc: "Pirinç, paslanmaz, oval ve süzgeç kuşgözü modelleri.",
    image: `${T}/kusgozu_princ.jpg`,
    items: [
      { name: "Pirinç / Paslanmaz Kuşgözü", image: `${T}/kusgozu_princ.jpg`, band: `${P}/kusgozu_princ.jpg`, sizes: ["5 mm", "6 mm", "7 mm", "8 mm", "9,5 mm", "11 mm", "12 mm", "14 mm"] },
      { name: "Oval Kuşgözü", image: `${T}/kusgozu_oval.jpg`, band: `${P}/kusgozu_oval.jpg`, sizes: ["7,5 x 19,5", "8,5 x 26", "13,5 x 23,5", "13,5 x 31", "14,5 x 26", "17 x 33,5"] },
      { name: "Süzgeç Kuşgözü", image: `${T}/kusgozu_suzgec.jpg`, band: `${P}/kusgozu_suzgec.jpg`, sizes: ["28 mm", "30 mm", "32 mm"] },
    ],
  },
  {
    id: "aski-kusgozu",
    name: "ASKI KUŞGÖZÜ",
    desc: "Perde ve hafif branda sistemleri için büyük çap askı kuşgözleri.",
    image: `${T}/aski_kusgozu.jpg`,
    items: [
      { name: "Askı Kuşgözü", image: `${T}/aski_kusgozu.jpg`, band: `${P}/aski_kusgozu.jpg`, sizes: ["26,5 mm", "40 mm", "41 mm", "42,5 mm", "43 mm"] },
    ],
  },
  {
    id: "pul-dikme-citcit",
    name: "PUL & DİKME ÇITÇIT",
    desc: "Plastik & metal pullar ve elde dikilen çıtçıt modelleri.",
    image: `${T}/dikme_citcit.jpg`,
    items: [
      { name: "Plastik Pul", image: `${T}/pul_plastik.jpg`, band: `${P}/pul_plastik.jpg`, sizes: ["9,5 mm", "12,5 mm", "15 mm", "17 mm", "21 mm"] },
      { name: "Metal Pul", image: `${T}/pul_metal.jpg`, band: `${P}/pul_metal.jpg`, sizes: ["9,5 mm", "12,5 mm", "15 mm", "17 mm", "21 mm"] },
      { name: "Dikme Çıtçıt", image: `${T}/dikme_citcit.jpg`, band: `${P}/dikme_citcit.jpg`, sizes: ["8,8 mm", "10 mm", "12,5 mm", "15 mm", "18 mm", "21 mm", "25 mm", "30 mm"] },
    ],
  },
  {
    id: "kot-dugme",
    name: "KOT DÜĞME",
    desc: "Denim ve dış giyim için pirinç & paslanmaz kot düğmeleri. 17 mm ve 20 mm.",
    image: `${T}/kot_K-0021.jpg`,
    individual: true,
    items: Array.from({ length: 32 }, (_, i) => {
      const code = `K-${(20 + i).toString().padStart(4, "0")}`;
      return { name: `Kot Düğme ${code}`, code, image: `${T}/kot_${code}.jpg`, sizes: ["17 mm", "20 mm"] };
    }),
  },
  {
    id: "percin",
    name: "PERÇİN",
    desc: "Memeli, göbekli, zamak perçinler ve alüminyum çiviler.",
    image: `${T}/percin_zamak.jpg`,
    items: [
      { name: "Memeli Perçin", image: `${T}/percin_memeli.jpg`, band: `${P}/percin_memeli.jpg`, sizes: ["9,5 mm", "12,5 mm"] },
      { name: "Göbekli Perçin", image: `${T}/percin_gobekli.jpg`, band: `${P}/percin_gobekli.jpg`, sizes: ["9,5 mm", "12,5 mm"] },
      { name: "Zamak Perçin", image: `${T}/percin_zamak.jpg`, band: `${P}/percin_zamak.jpg`, sizes: ["10 mm", "12,5 mm", "15 mm"] },
      { name: "Alüminyum Çivi", image: `${T}/percin_alcivi.jpg`, band: `${P}/percin_alcivi.jpg`, sizes: ["Standart"] },
    ],
  },
  {
    id: "toka",
    name: "TOKA",
    desc: "D tokalar ve zamak toka modelleri. 15 mm – 50 mm arası ölçüler.",
    image: `${T}/toka_KT-001.jpg`,
    individual: true,
    items: [
      { name: "D Toka", code: "D", image: `${T}/toka_d.jpg`, band: `${P}/toka_d.jpg`, sizes: ["15 mm", "20 mm", "25 mm", "32 mm", "40 mm", "50 mm"] },
      ...Array.from({ length: 10 }, (_, i) => {
        const code = i < 9 ? `KT-${(i + 1).toString().padStart(3, "0")}` : "KT-0010";
        return { name: `Toka ${code}`, code, image: `${T}/toka_${code}.jpg`, sizes: ["Zamak"] };
      }),
    ],
  },
  {
    id: "stoper",
    name: "STOPER",
    desc: "Zamak ve metalize stoper (kordon kilidi) modelleri.",
    image: `${T}/stoper_metalize.jpg`,
    items: [
      { name: "Zamak Stoper", image: `${T}/stoper_zamak.jpg`, band: `${P}/stoper_zamak.jpg`, sizes: ["Tekli", "Çiftli"] },
      { name: "Metalize Stoper", image: `${T}/stoper_metalize.jpg`, band: `${P}/stoper_metalize.jpg`, sizes: ["Tekli", "Çiftli", "Silindir"] },
    ],
  },
  {
    id: "bagucu",
    name: "BAĞUCU",
    desc: "Metalize ve zamak bağ ucu (kordel ucu) modelleri.",
    image: `${T}/bagucu_metalize.jpg`,
    items: [
      { name: "Metalize Bağucu", image: `${T}/bagucu_metalize.jpg`, band: `${P}/bagucu_metalize.jpg`, sizes: ["A4", "A13", "A50", "A60", "A592"] },
      { name: "Zamak Bağucu", image: `${T}/bagucu_zamak.jpg`, band: `${P}/bagucu_zamak.jpg`, sizes: ["Armut (K/O/B)", "Silindir", "Huni", "Dantel"] },
    ],
  },
  {
    id: "makine",
    name: "MAKİNE & KALIP",
    desc: "El presleri, montaj kalıpları ve KSN-808 full otomatik çakım makinesi.",
    image: `${T}/makina_elpres.jpg`,
    items: [
      { name: "El Presi", image: `${T}/makina_elpres.jpg`, band: `${P}/makina_elpres.jpg`, sizes: ["Manuel", "Şanzımanlı"] },
      { name: "Çıtçıt / Kuşgözü Kalıpları", image: `${T}/makina_kalp1.jpg`, band: `${P}/makina_kalp1.jpg`, sizes: ["Klikit", "Çıtçıt", "Kuşgözü", "Perçin"] },
      { name: "KSN-808 Full Otomatik Makine", image: `${T}/makina_ksn808.jpg`, band: `${P}/makina_ksn808.jpg`, sizes: ["Otomatik besleme", "Çoklu kalıp"] },
    ],
  },
];

export const COLOR_CHARTS = [
  {
    id: "standart",
    name: "STANDART RENKLER", title: "Standart renkler",
    desc: "Galvanik kaplama standart renk kartelamız.",
    colors: Array.from({ length: 24 }, (_, i) => {
      const code = 101 + i;
      return { code: `KSN ${code}`, name: "", image: `${T}/ksn_${code}.jpg` };
    }),
  },
  {
    id: "ozel",
    name: "SPECIAL RENKLER", title: "Special renkler",
    desc: "Özel efekt ve görünümlü kaplama renkleri.",
    colors: Array.from({ length: 12 }, (_, i) => {
      const code = 149 + i;
      return { code: `KSN ${code}`, name: "", image: `${T}/ksn_${code}.jpg` };
    }),
  },
  {
    id: "ekolojik",
    name: "ECOLOGICAL RENKLER", title: "Ecological renkler",
    desc: "Çevre dostu ekolojik kaplama renkleri.",
    colors: Array.from({ length: 12 }, (_, i) => {
      const code = 161 + i;
      return { code: `KSN ${code}`, name: "", image: `${T}/ksn_${code}.jpg` };
    }),
  },
];

export const STUDIO = [
  { image: `${P}/studio_1.jpg`, label: "Kemer Tokası Koleksiyonu" },
  { image: `${P}/studio_2.jpg`, label: "Halka & D Toka Detayı" },
  { image: `${P}/studio_3.jpg`, label: "Dokulu Zamak Kafa" },
  { image: `${P}/studio_4.jpg`, label: "Zamak Stoper Serisi" },
  { image: `${P}/studio_5.jpg`, label: "Ürün Yelpazesi" },
];

// İkinci parti atölye çekimleri (Hakkımızda galerisi)
export const STUDIO_GALLERY = [
  { image: `${P}/studio_15.jpg`, label: "Kot Düğme Çeşitleri" },
  { image: `${P}/studio_12.jpg`, label: "Kemer Tokası Serisi" },
  { image: `${P}/studio_19.jpg`, label: "JEANS Kot Düğme Koleksiyonu" },
  { image: `${P}/studio_6.jpg`, label: "Eskitme Kemer Tokası Çerçevesi" },
  { image: `${P}/studio_17.jpg`, label: "Çıtçıt Renk Seçenekleri" },
  { image: `${P}/studio_14.jpg`, label: "Dekoratif Baskılı Kot Düğmeleri" },
  { image: `${P}/studio_7.jpg`, label: "Üç Köprülü Ayar Tokası" },
  { image: `${P}/studio_18.jpg`, label: "Stoper Modelleri" },
  { image: `${P}/studio_13.jpg`, label: "Oval Kuşgözü Serisi" },
  { image: `${P}/studio_16.jpg`, label: "Prens (Klikit) Çıtçıt Parçaları" },
  { image: `${P}/studio_8.jpg`, label: "Sekizgen Halka Toka" },
  { image: `${P}/studio_20.jpg`, label: "Kot Düğme Yelpazesi" },
  { image: `${P}/studio_11.jpg`, label: "Çıtçıt & Perçin Montaj Parçaları" },
  { image: `${P}/studio_9.jpg`, label: "Kot Düğme & Perçin Parçaları" },
  { image: `${P}/studio_10.jpg`, label: "Çıtçıt Montaj Parçaları" },
];

export const PROMO_VIDEO = {
  src: "/videos/promo.mp4",
  poster: `${P}/promo_poster.jpg`,
};

export const GALLERY = [
  { image: `${P}/life_gomlek.jpg`, label: "Gömlek Grubu" },
  { image: `${P}/life_kanvas.jpg`, label: "Kanvas & Dış Giyim" },
  { image: `${P}/life_kadife.jpg`, label: "Kadife Koleksiyonu" },
  { image: `${P}/life_mont.jpg`, label: "Mont & Kaban" },
  { image: `${P}/life_yesil.jpg`, label: "Spor Giyim" },
  { image: `${P}/life_kot1.jpg`, label: "Denim Detay" },
  { image: `${P}/life_kot2.jpg`, label: "Denim Cep" },
  { image: `${P}/life_kot3.jpg`, label: "Denim Bel" },
  { image: `${P}/life_kot4.jpg`, label: "Denim Yıkama" },
  { image: `${P}/life_klikit1.jpg`, label: "Klikit Uygulama" },
  { image: `${P}/life_klikit2.jpg`, label: "Bebek Grubu" },
  { image: `${P}/life_bag1.jpg`, label: "Bağucu Detay" },
  { image: `${P}/life_bag2.jpg`, label: "Kapüşon Kordonu" },
  { image: `${P}/life_bag3.jpg`, label: "Sweatshirt" },
];

export const NAV_LINKS = [
  { to: "/", label: "Anasayfa" },
  { to: "/hakkimizda", label: "Hakkımızda" },
  { to: "/urunler", label: "Ürünler" },
  { to: "/renkler", label: "Renk Kartelası" },
  { to: "/iletisim", label: "İletişim" },
];
